export const ASSISTANT_SPOTLIGHT_DURATION_MILLISECONDS = 6000;
export const ASSISTANT_TARGET_WAIT_MILLISECONDS = 3000;
export const ASSISTANT_SPOTLIGHT_PADDING_PIXELS = 6;
export const ASSISTANT_CONVERSATION_PAGE_SIZE = 10;
export const ASSISTANT_AUTO_NAVIGATE_STORAGE_KEY_PREFIX = 'assistant.autoNavigate.';
export const ASSISTANT_SHORTCUT_KEY = 'k';
export const ASSISTANT_EXTRA_INSTRUCTIONS_MAX_CHARACTERS = 2000;
export const ASSISTANT_STREAM_INTERRUPTED_ERROR_CODE = 'assistant.stream_interrupted';
export const ASSISTANT_QUESTION_MAX_CHARACTERS = 4000;
export const ASSISTANT_QUESTION_COUNTER_THRESHOLD = 3500;
export const ASSISTANT_SCROLL_FOLLOW_THRESHOLD_PIXELS = 80;
export const ASSISTANT_SMALL_SCREEN_MEDIA_QUERY = '(max-width: 767px)';
export const ASSISTANT_REDUCED_MOTION_MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
export const ASSISTANT_MONTHLY_TOKEN_BUDGET_MAXIMUM = 2_147_483_647;
export const ASSISTANT_ATTENTION_BADGE_MAXIMUM = 9;

export const ASSISTANT_PANEL_SHOWS_PREFERENCE_TOGGLES = false;
